module.exports = __webpack_public_path__ + "static/img/7.03d8689.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/4/zh/7.png
// module id = f3Kd
// module chunks = 0